import React, { HTMLAttributes } from "react";
import { globalThemeAttributes } from "shared/config/global-theme-attributes";
import { TenantDaisyColorTheme } from "shared/model/theme";
import { twMerge } from "tailwind-merge";

import * as icons from "./svgs";

export type IconType = keyof typeof icons;

export type IconColor =
  | `fill-${keyof TenantDaisyColorTheme}`
  | `fill-${keyof typeof globalThemeAttributes.colors}`;

export type SvgIconProps = {
  color?: IconColor;
  icon: IconType;
} & HTMLAttributes<SVGSVGElement> &
  React.SVGProps<SVGSVGElement>;

export const SvgIcon: React.FC<SvgIconProps> = ({
  color = "fill-bg-blue-900",
  icon,
  className,
  width = "100%",
  height = "100%",
  ...rest
}) => {
  return React.createElement(icons[icon] ?? icons.empty, {
    className: twMerge(color, className),
    width,
    height,
    ...rest,
  });
};
